import { render, staticRenderFns } from "./ProjectAttachments.vue?vue&type=template&id=3a67a15c&"
import script from "./ProjectAttachments.vue?vue&type=script&lang=js&"
export * from "./ProjectAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports